import { Buffer } from "buffer";
import React, { useEffect, } from "react";

const FaviconRetrieval = ({ favicon }) => {
  const retrieveFavicon = () => {
      let bufferedImage = "%PUBLIC_URL%/favicon.ico";
      let mimetype = '';
      let lastIndex = null;
      if (favicon && favicon.length > 0) {
        lastIndex = favicon[favicon.length - 1];

        mimetype = lastIndex.mimetype;
        bufferedImage = "data:" + mimetype + ";base64," 
          + Buffer.from(lastIndex.buffer.data).toString('base64');
      }

      if(lastIndex && !lastIndex.storedInFileSystem ){
        const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
        link.type = mimetype;
        link.rel = 'shortcut icon';
        link.href = bufferedImage;
        document.getElementsByTagName('head')[0].appendChild(link);
      }

  }

  useEffect(() => {
    retrieveFavicon();
  }, [favicon])

  return (
    <>
    </>
  )
}
export default FaviconRetrieval;
